<template>
<div class="mx-3">
    <v-row no-gutters>
        <v-col cols="6">
            <div class="important">Service</div>
            <div class="regular">{{ item.service }}</div>
        </v-col>
        <v-col cols="6">
            <div class="important">Path</div>
            <div class="regular">{{item.path}}</div>
        </v-col>
        <v-col cols="12" my-3>
            <div class="important">Events</div>
            <v-row no-gutters>
                <v-chip class="ma-1" v-for="(id, index) in item.events" :key="index">{{filteredEvents(id)}}</v-chip>
            </v-row>
        </v-col>
    </v-row>
</div>
</template>

<script>
import defaults from "../utils/PropDefaults.js"

export default {
    props: {
        item: {
            type: Object,
            default: defaults.listener_item
        },
        events: Array,
    },
    methods: {
        emitClick() {
            this.$emit('click');
        },
        filteredEvents: function (id) {
            let events = this.events.filter((item) => {
                if(item.value === id) return item;
            });
            return events.length > 0 ? events[0].text : null;
        }
    },
}
</script>
